import { cdataFetch } from "../cdataFetch";

export function stopCacheJob(params: { jobId: string }) {
  return cdataFetch<void>({
    method: "PUT",
    url: `/cacheJobs/stop/${params.jobId}`,
  });
}
